const otherRU = {
    occupations: {
        sleep: "спит",
        wakeup: "просыпается",
        shower: "принимает душ",
        breakfast: "завтракает",
        reading: "читает",
        lessons: "занимается",
        cook: "готовит",
        run: "бегает",
        clean: "убирается",
        officeJob: "работает в офисе"
    },
    now: "сейчас",
    apostrophe: "",
    menus: {
        information: "Информация",
        occupation: "Занятие",
        appearance: "Внешний вид",
        phone: "Телефон"
    },
    appearance: {
        appearance: "Внешний вид",
        face: "Лицо",
        dress: "Одежда",
        bra: "Бра",
        underpants: "Трусы"
    },
    information: {
        home: "Текущий дом:",
        car: "Текущая машина:",
        missions: "Миссии:"
    },
    phone: {
        gallery: "галерея",
        contacts: "контакты"
    },
    missions: {
        noTasks: "У миссии нет заданий",
        initCorruption_01: {
            name: "Преодоление. Начало.",
            description: "У твоей жены что-то типа психологического расстройства, которое не позволяет ей устроиться на работу. " +
                "К счастью, случайным образом к тебе попали таблетки, которые смогут ей с этим помочь... Хочешь ли ты этого?"
        },
        checkInstruction_01: {
            name: "Просмотреть Инструкцию к таблеткам",
            description: "Ты положил таблетки в свой стол в спальне. Нужно для начала почитать инструкцию к ним."
        },
        getInfoAboutDrink_01: {
            name: "Спросить про Напиток",
            description: "Каким-то образом тебе нужно заставить жену выпить таблетку. Для начала нужно узнать, какой напиток ей больше всего хочется выпить.",
            conditions: "relations > 13, жена не в душе и не спит"
        },
        buyADrink_01: {
            name: "Купить Piña Colada",
            description: "Следующий шаг: купить этот напиток. Можно поехать в город и поискать его в одном из супермаркетов.",
            conditions: "50$ в кармане, часть дня - Вечер"
        },
        treatWifePill_01: {
            name: "Как-то дать ей таблетку",
            description: "Теперь осталось только угостить её напитком (Скорее всего он лежит в холодильнике). Нужно это сделать до приёма пищи.",
            conditions: "relations > 15, часть дня - \"Start of Morning\" или \"Start of Evening\", где: Кухня"
        },
        checkChanges_01: {
            name: "Проверить, есть ли изменения",
            description: "Не знаю, будет ли вообще эффект от этих таблеток и когда. Нужно постоянно спрашивать у жены, как она себя чувствует.",
            conditions: "relations > 22"
        },
        askAtOfficeAboutWife_01: {
            name: "Узнать о работе в Офисе",
            description: "Да! Не могу поверить, что таблетки реально работают. Мне нужно помочь ей и узнать, есть ли у нас в офисе вакансии для неё.",
            conditions: "где: Офис"
        },
        tellWifeAboutJobOps_01: {
            name: "Рассказать жене о вакансии",
            description: "Осталось только рассказать ей, что вакансия есть и она открыта и дождаться, чтобы она туда позвонила... Не верю, что всё так просто."
        },
        goToInterviewAsWife_01: {
            name: "Пойти на интервью женой",
            description: "Мне необходимо сходить на собеседование на работу. Надеюсь, всё пройдет гладко.",
            conditions: "Играть за жену, часть дня: Утро"
        },
        goHome_01: {
            name: "Пойти домой, чтобы поздравить её.",
            description: "Она устроилась на работу! Ну что же, нужно поздравить её."
        },
    },

    messages: {
        player: {
            mes01_01: "Люблю тебя!",
            mes01_02: "Люблю тебя тоже, детка <3",
            mes01_03: "❤️",
            mes01_04: "❤️",
            mes02_01: "Эй, детка! Как ты?",
            mes02_02: "Отлично, ты?",
            mes02_03: "Я иду в центр города на бизнес встречу. Пожелай мне удачи!",
            mes02_04: "Удачи, детка ❤️",
            mes03_01: "Посмотри, что я нашла в интернете! Новый мем о котах!",
            mes03_03: "ЛОЛ! Выглядит, как будто он очень несчастен!",
            mes03_04: "Не говори! Он потрясающий!",
            mes04_01: "Как дела, детка?",
            mes04_02: "Хорошо, у тебя?",
            mes04_03: "работа оооочень скучная",
            mes04_04: "может отправишь мне своё фото чтобы меня развеселить?",
            mes04_05: "Я не делаю такие фото, ты сам прекрасно знаешь",
            mes04_06: "точно, точно...",
            mes05_01: "Меня приняли!!!!",
            mes05_02: "Реально??? Я так рад за тебя, отпразднуем сегодня?",
            mes05_03: "Как сам хочешь",
            mes05_04: "ок"
        }
    },

    places: {
        homeMain: {
            work: "Поехать на работу",
            goBuyPinaColada: "Поехать в супермаркет и купить бутылку Piña colada",
            wifeOfficeInterview: "Поехать в офис для прохождения интервью",
            goHome: "Пойти домой"
        },
        homeBedroom: {
            table: "Компьютерный стол",
            bed: "Кровать",
            kitchen: "Кухня",
            bathroom: "Спальня",
            outside: "Выйти на улицу"
        },
        homeKitchen: {
            bottle: "Piña colada",
            bedroom: "Спальня"
        },
        homeBathroom: {
            bedroom: "Спальня"
        },
        pillsMenu: {
            pills: "Прочитать инструкцию",
            back: "Назад"
        },
        bedMenu: {
            sleep: "Пойти спать",
            nap: "Прилечь ненадолго",
            back: "Назад"
        },
        wifeMenu: {
            chat: "Поболтать",
            howSheFeels: "Узнать, как она себя чувствует",
            makeOut: "Целоваться",
            bathTogether: "Предложить принять душ вместе",
            getWifeInfoAboutDrink: "Попробовать узнать о любимом напитке",
            tellWifeAboutJobInOffice: "Сказать ей о работе в офисе",
            checkHerAss: "Посмотреть её задницу",
            wifeSexMenu: "Сексуальные взаимодействия",
            back: "Назад"
        },
        wifeDressUpMenu: {
            jeans: "Джинсы и Пуловер",
            back: "Назад"
        },
        wifeSexMenu: {
            handsJob: "Ручная работа",
            blowjob: "Работа ртом",
            sex: "Секс",
            analSex: "Анальный секс",
            back: "Назад"
        },
        rentMenu: {
            rentPayment: "Отнести деньги владельцу"
        },
        courier: {
            courierJob: "Выйти на смену",
            courierGoHome: "Поехать домой",
            courierGoToOffice: "Посетить офис"
        },
        courierOffice: {
            someGuy: "Какой-то парень",
            colleagues: "Коллеги",
            back: "Назад"
        },
        table: {
            playComputer: "Немного поиграть в компьютер",
            watchPorn: "Посмотреть порно",
            pillsMenu: "Таблетки",
            back: "Назад"
        }
    }
};

export default otherRU;